import React from "react";
import PropTypes from "prop-types";
import { Table, Tag } from "antd";

const ProblematicStockTable = ({
  dataSource,
  loading,
  pagination,
  onChange,
}) => {
  const columns = [
    {
      title: "Barcode",
      dataIndex: "barcode",
      key: "barcode",
      width: 120,
      fixed: "left",
      sorter: (a, b) => (a.barcode || "").localeCompare(b.barcode || ""),
    },
    {
      title: "Article",
      dataIndex: "article",
      key: "article",
      width: 150,
      sorter: (a, b) => (a.article || "").localeCompare(b.article || ""),
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      width: 100,
      sorter: (a, b) => (a.color || "").localeCompare(b.color || ""),
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      width: 80,
      sorter: (a, b) => (a.size || "").localeCompare(b.size || ""),
    },

    {
      title: "Counter",
      dataIndex: "counterCode",
      key: "counterCode",
      width: 100,
      sorter: (a, b) => (a.counterCode || "").localeCompare(b.counterCode || ""),
    },

    {
      title: "No SJ",
      dataIndex: "noSJ",
      key: "noSJ",
      width: 120,
      sorter: (a, b) => (a.noSJ || "").localeCompare(b.noSJ || ""),
      render: (noSJ) => {
        if (!noSJ) {
          return <Tag color="red">No SJ</Tag>;
        }
        if (noSJ.startsWith("ADJ")) {
          return <Tag color="green">{noSJ}</Tag>;
        }
        return <Tag color="orange">{noSJ}</Tag>;
      },
    },
    {
      title: "Add on Quantity",
      dataIndex: "receivedQuantity",
      key: "receivedQuantity",
      width: 120,
      align: "right",
      sorter: (a, b) => (a.currentQuantity || 0) - (b.currentQuantity || 0),
      render: (quantity) => {
        const num = Number(quantity) || 0;
        return (
          <span style={{ fontWeight: num > 0 ? "bold" : "normal" }}>
            {num.toLocaleString()}
          </span>
        );
      },
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      rowKey="_id"
      scroll={{ x: 1500 }}
      size="small"
      bordered
    />
  );
};

ProblematicStockTable.propTypes = {
  dataSource: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  pagination: PropTypes.object,
  onChange: PropTypes.func,
};

export default ProblematicStockTable;
